import { LINK_FROM_APP_PLATFORMS } from '$lib/utils/constants';

/** `linkFromAppPlatform` values that mean the user entered this web flow from an ABCmouse iOS app link. */
const IOS_APP_LINK_PLATFORMS = new Set([
	LINK_FROM_APP_PLATFORMS.IOS,
	LINK_FROM_APP_PLATFORMS.IOS_1_0,
	LINK_FROM_APP_PLATFORMS.IOS_2_0,
]);

/** `linkFromAppPlatform` values that mean the user entered this web flow from an ABCmouse Android app link. */
const ANDROID_APP_LINK_PLATFORMS = new Set([
	LINK_FROM_APP_PLATFORMS.ANDROID,
	LINK_FROM_APP_PLATFORMS.ANDROID_1_0,
	LINK_FROM_APP_PLATFORMS.ANDROID_2_0,
	LINK_FROM_APP_PLATFORMS.SAMSUNG,
]);

/**
 * True when the session was opened from an iOS app link (`ios`, `ios_1_0`, or `ios_2_0`).
 * Used to attach analytics event types (subscribe / upgrade / auxiliary) that feed server-side Adjust.
 * This is separate from `regPathKey` / subscription registration path, which come from product config or user metadata.
 * @param {string | null | undefined} linkFromAppPlatform - e.g. `$app.global.linkFromAppPlatform`
 * @returns {boolean}
 */
export function isEntryFromIosAppLink(linkFromAppPlatform) {
	return typeof linkFromAppPlatform === 'string' && IOS_APP_LINK_PLATFORMS.has(linkFromAppPlatform);
}

/**
 * True when the session was opened from an Android or Samsung app link (`android`, `android_1_0`, `android_2_0`, or `samsung`).
 * Mirrors `isEntryFromIosAppLink` for the Android/Samsung alt payment flow.
 * @param {string | null | undefined} linkFromAppPlatform - e.g. `$app.global.linkFromAppPlatform`
 * @returns {boolean}
 */
export function isEntryFromAndroidAppLink(linkFromAppPlatform) {
	return (
		typeof linkFromAppPlatform === 'string' && ANDROID_APP_LINK_PLATFORMS.has(linkFromAppPlatform)
	);
}

/**
 * True when the session was opened from either an iOS or Android app link.
 * Used to gate server-side Adjust tracking for the alt payment flow on both platforms.
 * @param {string | null | undefined} linkFromAppPlatform - e.g. `$app.global.linkFromAppPlatform`
 * @returns {boolean}
 */
export function isEntryFromAltPaymentAppLink(linkFromAppPlatform) {
	return (
		isEntryFromIosAppLink(linkFromAppPlatform) || isEntryFromAndroidAppLink(linkFromAppPlatform)
	);
}
